import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { handleRecruiter, Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'dm-response',
		path: '/p/:petitionSlugOrId/responses/:responseId',
		component: loadable(async () => import(/* webpackChunkName: "pages/dm_response" */ './index'), {
			exportName: 'DecisionMakerResponse',
			fallback: Loading,
		}),
		frame: true,
		beforeServerRender: async (context) => {
			await handleRecruiter(context, context.params.petitionSlugOrId);
		},
		ssr: {
			enabled: true,
			seo: true,
		},
	},
];
